import styled from 'styled-components'
import ModalBootstrap from 'react-bootstrap/Modal'

export const Modal = styled(ModalBootstrap)<{ zindex: number }>`
  z-index: ${({ zindex }) => zindex};
`

export const ExitButton = styled.button`
  border: 0;
  background-color: inherit;
  display: flex;
  justify-content: center;
  color: inherit;
  svg {
    opacity: 0.5;
  }
  :hover {
    transition: 200ms ease-in-out;
    svg {
      opacity: 1;
    }
  }
  :focus {
    border: 0;
    outline: 0;
    svg {
      opacity: 1;
    }
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`

export const ModalBody = styled.div`
  padding: 15px;
`

export const ModalHeader = styled(ModalBootstrap.Header)<{color: string}>`
  background-color: ${({ color }) => color};
  flex: 1 1 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  font-weight: semibold;
  color: #FFF;
  padding: 12px;
`

export const ModalFooter = styled.div<{color: string}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: ${({ color }) => color};
`

export const BaseButton = styled.button`
  min-width: 150px;
  min-height: 40px;
  color: #fff;
  padding: 4px 16px;
  margin-right: 5px;
  border-radius: 1px;
  box-shadow: 0px 3px 14px rgba(0, 0, 0, 0.16);
  border: 0;
  cursor: pointer;
  :hover {
    transition: 200ms ease-in-out;
  }
`

export const CancelButton = styled(BaseButton)<{color: string, hoverColor: string}>`
  background-color: ${({ color }) => color};
  :hover {
    background-color: ${({ hoverColor }) => hoverColor};
  }
`

export const ConfirmButton = styled(BaseButton)<{color: string, hoverColor: string}>`
  background-color: ${({ color }) => color};
  :hover {
    background-color: ${({ hoverColor }) => hoverColor};
  }
`
